import { css } from "emotion";
import accessibilityIcon from "../../../assets/icons/ic_accessibility.svg";

const accessibilityLink = css({
  color: "#196097",
  background: `url(${accessibilityIcon})`,
  backgroundSize: "20px 20px",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "calc(50% - 38px) 50%",
  paddingLeft: 40,
  fontWeight: 600,
  borderRadius: 4,
  fontSize: 14,
  backgroundColor: "#f9f9fa",
  width: "100%",
  display: "block",
  marginBottom: 24,
  textAlign: "center",
  height: 32,
  paddingTop: 6,
  ":hover": {
    color: "#196097"
  }
});

const AccessibilityComponent = ({ displayAccessibility, event }) => {
  if (displayAccessibility) {
    return (
      <div>
        <a
          href={`/${event.data.slug}/accessibility?source=tickets`}
          className={accessibilityLink}
        >
          Accessibility
        </a>
      </div>
    );
  }
  return null;
};

export default AccessibilityComponent;



// WEBPACK FOOTER //
// ./routes/tickets/components/AccessibilityComponent.js